import {z} from 'zod';
import {CreateActionClassRequest} from '../api/generated/index.defs.ts';
import {mapNullToUndefined} from '../utils/zod.ts';

export const actionClassSchema = z.object({
  class: z.string(),
  codeId: z.number(),
  actionCodeId: z.number(),
  canBeChanged: mapNullToUndefined(z.boolean().optional()),
}) satisfies z.Schema<CreateActionClassRequest>;
export type ActionClassSchema = z.TypeOf<typeof actionClassSchema>;
